export enum FeedbackRequestType {
    ASK_A_TEACHER = "Ask a Teacher",
    WRITING_FEEDBACK = "Writing Feedback",
    LIVE_CLASS_FEEDBACK = "Live Class Feedback",
    LEVEL_TEST_FEEDBACK = "Level Test Feedback",
    MID_LEVEL_TEST_FEEDBACK = "Mid-Level Test Feedback"
  }


// WEBPACK FOOTER //
// ./ts/app/shared/types/feedback-request-type.ts